module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Set Color")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-modal-color-body plekan-clearfix",
    slot: "body"
  }, [_c('div', {
    staticClass: "plekan-color-type plekan-clearfix"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colortype),
      expression: "colortype"
    }],
    staticClass: "plekan-form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.colortype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "backColor"
    }
  }, [_vm._v("Background Color")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hiliteColor"
    }
  }, [_vm._v("Block Color")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "foreColor"
    }
  }, [_vm._v("Text Color")])]), _vm._v(" "), _c('a', {
    staticClass: "plekan-remove-color",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exec('removeFormat')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-color-pallate plekan-clearfix"
  }, _vm._l((_vm.colors), function(c) {
    return _c('a', {
      style: ({
        backgroundColor: c
      }),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setColor(c)
        }
      }
    })
  }))]), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6b0886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/colorModal.vue
// module id = 117
// module chunks = 0